module.exports = global["ocmsJQuery"] = require("-!.\\jquery.js");


//////////////////
// WEBPACK FOOTER
// ../node_modules/expose-loader?ocmsJQuery!../node_modules/jquery/src/jquery.js-exposed
// module id = 1261
// module chunks = 21 22 29 30